import type { ShipmentListItemVendorApi } from '@/views/screens/Shipment/types';
import { convertDateESTToUTCToUserLocal } from '../../utilz/dates';
import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import POShipmentSearchTypes from './POShipmentSearchTypes';

export interface POShipmentSearchState extends Record<string, any> {
  shipmentInfoList: DefaultStoreObject<ShipmentListItemVendorApi[]> & {
    totalCount: number;
  };
}

const initialState: POShipmentSearchState = {
  shipmentInfoList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalCount: 0,
  },
  shipmentInfoListReq: {
    customerKey: 0,
    vendorKey: 0,
    carrierKey: 0,
    poNumber: '',
    shipmentNo: '',
    createdOnFrom: '',
    createdOnTo: '',
    shipmentType: 'Final',
    pageIndex: 0,
    pageSize: 10,
    orderByColumn: '',
    orderBySort: '',
  },
  shipmentSearchExportVisible: false,
  shipmentSearchExportData: {
    data: [],
  },
  isSelectedAllItemsForPoShipment: false,
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const POShipmentSearchReducer = (state = initialState, { type, payload }: any): POShipmentSearchState => {
  switch (type) {
    case POShipmentSearchTypes.SET_SHIPEMENT_SEARCH_EXPORT_TOGGLE: {
      return {
        ...state,
        shipmentSearchExportVisible: payload.show || false,
        shipmentSearchExportData: {
          data: payload.data,
        },
      };
    }
    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          progressing: true,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_SUCCESS: {
      payload.data?.item2.forEach((element: ShipmentListItemVendorApi) => {
        element.isChecked = state.isSelectedAllItemsForPoShipment || false;
        element.expShipDate = convertDateESTToUTCToUserLocal(element.expShipDate);
        element.expDeliveryDate = convertDateESTToUTCToUserLocal(element.expDeliveryDate);
        element.shipmentDate = convertDateESTToUTCToUserLocal(element.shipmentDate);
        element.createdOn = convertDateESTToUTCToUserLocal(element.createdOn);
      });
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          success: true,
          totalCount: payload.data?.item1?.totalCount,
          data: [...(state.shipmentInfoList.data || []), ...(payload?.data?.item2 ?? [])],
          progressing: false,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_FAIL: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          error: true,
          success: false,
          progressing: false,
        },
      };
    }

    case POShipmentSearchTypes.SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          progressing: true,
        },
      };
    }

    case POShipmentSearchTypes.SAVE_SHIPMENT_OTHER_DETAILS_SUCCESS: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          success: true,
          progressing: false,
        },
      };
    }

    case POShipmentSearchTypes.SAVE_SHIPMENT_OTHER_DETAILS_FAIL: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          error: true,
          success: false,
          progressing: false,
        },
      };
    }

    case POShipmentSearchTypes.GET_SHIPMENT_INFO_LIST_RESET: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          totalCount: 0,
        },
      };
    }

    case POShipmentSearchTypes.UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS: {
      const temp: ShipmentListItemVendorApi[] = [];
      state.shipmentInfoList.data?.forEach((item) => {
        if (payload === true || payload === false) {
          item.isChecked = payload;
        } else {
          if (payload.shipmentKey === item.shipmentKey) {
            item.isChecked = !item.isChecked;
          }
        }
        temp.push(item);
      });
      const findSelectedItem = state.shipmentInfoList.data?.filter((item) => item.isChecked);

      return {
        ...state,
        isSelectedAllItemsForPoShipment:
          findSelectedItem?.length &&
          state.shipmentInfoList?.data?.length &&
          findSelectedItem?.length === state.shipmentInfoList?.data?.length,
        shipmentInfoList: {
          ...state.shipmentInfoList,
          data: temp,
        },
      };
    }

    case POShipmentSearchTypes.UPDATE_SHIPMENT_INFO_LIST_REQUEST: {
      return {
        ...state,
        shipmentInfoListReq: {
          ...state.shipmentInfoListReq,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

export default POShipmentSearchReducer;
